module.exports = __webpack_public_path__ + "img/vendor-icon.e7f90ea8.svg";